import cs from '../translations/cs.js'
import en from '../translations/en.js'
import hr from '../translations/hr.js'
import pl from '../translations/pl.js'
import sk from '../translations/sk.js'
import de from '../translations/de.js'

const languages = {
    cs,
    en,
    hr,
    pl,
    sk,
    de
}

// Získáme aktuální jazyk z data layer
const currentLanguage = getShoptetDataLayer('language')

// Funkce pro překlad klíčů
export function _t(key) {
    const langPack = languages[currentLanguage]

    if (!langPack) {
        console.warn(`Překlady pro jazyk '${currentLanguage}' nejsou k dispozici, vracím klíč '${key}'`)
        return key
    }

    // Získáme překlad pro daný klíč a aktuální jazyk

    const translation = langPack[key]
    // Pokud překlad neexistuje, vypíšeme chybu do konzole a vrátíme původní klíč
    if (!translation) {
        console.error(`Překlad '${key}' nebyl nalezen pro jazyk '${currentLanguage}'`)
        return key
    }

    return translation
}
// Funkce prověřuje existenci daného elementu v DOM. Pokud existuje, vrátí jej. Pokud ne, funkce čeká na jeho vytvoření.
export function waitForElement(selector, context) {
    return new Promise((resolve) => {
        const existingElement = context ? $(context).find(selector) : $(selector)
        if (existingElement.length) {
            resolve(existingElement)
            return
        }

        const observer = new MutationObserver((mutations) => {
            const element = context ? $(context).find(selector) : $(selector)

            if (element.length) {
                resolve(element)
                observer.disconnect()
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })
    })
}

// Funkce pro skrytí banneru ve footeru po manipulaci s ním
export function hideParentBanner(element) {
    const bannerElement = $(element)
    const parentElement = bannerElement.closest('.banner').parent()
    parentElement.hide()
    parentElement.addClass('hidden-by-script')
}

export function isTablet() {
    return $(window).width() <= 991
}

export function isMobile() {
    return $(window).width() <= 767
}

export function isMobileXs() {
    return $(window).width() <= 479
}

export function isMobileBodyClass() {
    return $('body').hasClass('mobile')
}

export function getCombinedSidesPadding(selector) {
    const element = document.querySelector(selector)
    const styles = getComputedStyle(element)
    return parseInt(styles.paddingLeft) + parseInt(styles.paddingRight)
}

export function scrollToElement(element, scrollUp) {
    function getScrollPadding() {
        const rootStyles = getComputedStyle(document.documentElement)
        return parseInt(rootStyles.getPropertyValue('--scroll-padding'), 10) || 0
    }
    // Up je výška horního headeru, který je schovaný. Většinou header-top
    let up = 0

    if (scrollUp) {
        up = 81
    }

    const scrollPadding = getScrollPadding()
    const elementTop = $(element).offset().top
    const scrollDiv = elementTop - scrollPadding - up

    window.scrollTo({ top: scrollDiv, behavior: 'smooth' })
}

export function getElementHeight(selector) {
    const element = $(selector)
    return element.is(':visible') ? element.outerHeight() : 0
}

export function createCustomSwiper(element, options = {}) {
    const {
        swiperClass,
        swiperChildrenClass = '',
        pagination = false,
        arrows = true,
        arrowsOutside = false,
        customOptions = {},
    } = options

    const targetElement = document.querySelector(element)

    if (!targetElement) return

    const childrenHTML = Array.from(targetElement.children)
        .map(
            (child) => /*HTML*/ `
          <div class="swiper-slide ${swiperChildrenClass}">
            ${child.innerHTML}
          </div>
          `
        )
        .join('')

    const swiperHTML = /* HTML */ `
              ${arrows && arrowsOutside ? '<div class="swiper-container">' : ''}

            <div class="swiper custom-swiper ${swiperClass}">
                <div class="swiper-wrapper">${childrenHTML}</div>
                ${
                    pagination
                        ? /* HTML */ `
                              <div class="swiper-pagination-wrapper">
                                  <div class="swiper-pagination ${swiperClass}-pagination"></div>
                              </div>
                          `
                        : ''
                }
                ${
                    arrows && !arrowsOutside
                        ? /* HTML */ `
                              <div class="swiper-navigation ${swiperClass}-navigation">
                                  <div class="swiper-button-prev ${swiperClass}-button-prev"></div>
                                  <div class="swiper-button-next ${swiperClass}-button-next"></div>
                              </div>
                          `
                        : ''
                }
            </div>
            ${
                arrows && arrowsOutside
                    ? /* HTML */ `
                          <div class="swiper-navigation ${swiperClass}-navigation">
                              <div class="swiper-button-prev ${swiperClass}-button-prev"></div>
                              <div class="swiper-button-next ${swiperClass}-button-next"></div>
                          </div>
                      `
                    : ''
            }
            ${arrows && arrowsOutside ? '</div>' : ''}
        </div>
    `

    targetElement.insertAdjacentHTML('afterend', swiperHTML)
    targetElement.classList.add('hide')

    const defaultOptions = {
        loop: true,
        pagination: pagination
            ? {
                  el: `.${swiperClass}-pagination`,
                  clickable: true,
              }
            : false,
        navigation: arrows
            ? {
                  nextEl: `.${swiperClass}-button-next`,
                  prevEl: `.${swiperClass}-button-prev`,
              }
            : false,
    }

    new Swiper(`.${swiperClass}`, { ...defaultOptions, ...customOptions })
}

function createSwiperContainer(index, options = {}) {
    const { arrows = true, pagination = false } = options

    return /* HTML */ `
        <div class="swiper-products-container section-${index}">
            <div class="swiper swiper-products-tab">
                <div class="swiper-wrapper products-block"></div>
                ${pagination
                    ? `
                    <div class="swiper-pagination"></div>
                `
                    : ''}
            </div>
            ${arrows
                ? `
                <div class="swiper-navigation">
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
            `
                : ''}
        </div>
    `
}

function cloneProductsToSwiper(wrapper, sectionIndex) {
    const addedProductIds = []

    wrapper.find('.product').each(function () {
        const product = $(this)
        const productId = product.find('.p').attr('data-micro-product-id')

        if (!addedProductIds.includes(productId)) {
            const clonedProduct = product.clone().attr('class', 'product swiper-slide').removeAttr('style')

            addedProductIds.push(productId)

            $(`.swiper-products-container.section-${sectionIndex}`)
                .find('.swiper-wrapper.products-block')
                .append(clonedProduct)
        }
    })
}

export function createSwiperProductBlocks(selector = '.products-wrapper', options = {}) {
    const { arrows = true, pagination = false } = options

    $(selector).each(function (i) {
        const wrapper = $(this)
        wrapper.after(createSwiperContainer(i, { arrows, pagination }))

        cloneProductsToSwiper(wrapper, i)

        wrapper.hide()

        new Swiper(`.section-${i} .swiper-products-tab`, {
            slidesPerView: 2,
            loop: true,
            navigation: arrows
                ? {
                      nextEl: `.section-${i} .swiper-button-next`,
                      prevEl: `.section-${i} .swiper-button-prev`,
                  }
                : false,
            pagination: pagination
                ? {
                      el: `.section-${i} .swiper-pagination`,
                      clickable: true,
                  }
                : false,
            spaceBetween: 12,
            breakpoints: {
                768: {
                    slidesPerView: 5,
                },
            },
        })
    })
}
